import { getApiBaseUrl } from './apiBaseUrl';

const cacheStore = new Map();

const loadJsonWithAuth = async (path) => {
  const token = localStorage.getItem('token');
  if (!token) {
    throw new Error('Missing auth token');
  }

  const response = await fetch(`${getApiBaseUrl()}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  if (!response.ok) {
    throw new Error(`Request failed for ${path}`);
  }

  return response.json();
};

const getCachedValue = async (key, ttlMs, loader, { force = false } = {}) => {
  const now = Date.now();
  const cached = cacheStore.get(key);

  if (!force && cached?.value !== undefined && cached.expiresAt > now) {
    return cached.value;
  }

  if (!force && cached?.promise) {
    return cached.promise;
  }

  const promise = loader()
    .then((value) => {
      cacheStore.set(key, {
        value,
        expiresAt: Date.now() + ttlMs,
        promise: null,
      });
      return value;
    })
    .catch((error) => {
      const previous = cacheStore.get(key);
      if (previous?.value !== undefined) {
        cacheStore.set(key, { ...previous, promise: null });
      } else {
        cacheStore.delete(key);
      }
      throw error;
    });

  cacheStore.set(key, {
    value: cached?.value,
    expiresAt: cached?.expiresAt || 0,
    promise,
  });

  return promise;
};

export const getCachedSystemInfo = (options = {}) =>
  getCachedValue('system-info', 5 * 60 * 1000, () => loadJsonWithAuth('/api/system/info'), options);

export const getCachedAccessibleStores = (options = {}) =>
  getCachedValue('accessible-stores', 5 * 60 * 1000, () => loadJsonWithAuth('/api/stores/accessible'), options);

export const getCachedBackupRetentionAlert = (options = {}) =>
  getCachedValue('backup-retention-alert', 2 * 60 * 1000, () => loadJsonWithAuth('/api/admin/backup/retention-alert'), options);

export const invalidateRuntimeMetaCache = (...keys) => {
  keys.forEach((key) => cacheStore.delete(key));
};